import { waLink, WA_MESSAGES, trackWhatsApp } from "@/lib/whatsapp";
import Reveal from "./Reveal";
import WhatsAppIcon from "./WhatsAppIcon";

const STEPS = [
  {
    num: "01",
    title: "Escolha sua experiência",
    text: "Veja o catálogo e escolha o passeio que combina com você e com o seu tempo.",
  },
  {
    num: "02",
    title: "Fale comigo pelo WhatsApp",
    text: "Me chame para consultar disponibilidade, valores e condições da reserva.",
  },
  {
    num: "03",
    title: "Receba as orientações",
    text: "Você recebe todas as informações de horário, ponto de encontro e o que levar.",
  },
  {
    num: "04",
    title: "Aproveite o Rio",
    text: "Com a reserva confirmada, é só chegar e aproveitar a experiência sem pressa.",
  },
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="mx-auto max-w-7xl scroll-mt-24 px-5 py-24 sm:px-8 sm:py-32" data-testid="how-it-works-section">
      <Reveal>
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
          Como funciona
        </p>
        <h2 className="mt-4 max-w-3xl font-display text-3xl font-extrabold leading-tight tracking-tight text-stone-50 sm:text-4xl lg:text-5xl">
          Simples do início{" "}
          <em className="font-accent font-medium italic text-amber-400">ao fim.</em>
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((step, i) => (
          <Reveal key={step.num} delay={i * 0.12}>
            <article className="group h-full rounded-2xl border border-white/10 bg-[#161B22] p-7 transition-[border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-amber-400/40">
              <span className="font-mono text-4xl font-bold text-amber-400/25 transition-colors duration-500 group-hover:text-amber-400/60">
                {step.num}
              </span>
              <h3 className="mt-5 font-display text-lg font-bold text-stone-50">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-stone-400">{step.text}</p>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-12">
        <a
          href={waLink(WA_MESSAGES.default)}
          onClick={() => trackWhatsApp("como_funciona")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="how-it-works-cta"
          className="inline-flex items-center gap-2.5 rounded-full bg-[#25D366] px-8 py-4 text-sm font-bold uppercase tracking-wider text-white shadow-[0_0_40px_rgba(37,211,102,0.3)] transition-[background-color,transform] duration-300 hover:scale-[1.03] hover:bg-[#20BD5A]"
        >
          <WhatsAppIcon className="h-4 w-4" />
          Quero reservar pelo WhatsApp
        </a>
      </Reveal>
    </section>
  );
}
